(() => {
  if (window.Shopify?.designMode || window.pcConfiguratorTracking) return;
  window.pcConfiguratorTracking = true;
  const states = new WeakMap();
  const roots = new Set();
  const watched = new WeakSet();
  const targets = new WeakMap();
  const colors = { 'Zlatá':'gold', 'Strieborná':'silver', 'Čierna':'black', 'Bronzová':'bronze', 'Bez':'none', 'Baby blue':'baby_blue', 'Baby pink':'baby_pink', 'Fialová':'purple', 'Žltá':'yellow', 'Zelená':'green', 'Oranžová':'orange', 'Hnedá':'brown', 'Biela':'white', 'Červená':'red', 'Modrá':'blue', 'Ružová':'pink' };
  const fields = {220579:'eyelets',667408:'elastic',872434:'charms_text',674810:'foil',684923:'foil_text',349395:'laser_front',157937:'laser_back',18070:'laser_inside_left',686525:'laser_inside_outer',985549:'laser_inside_right'};
  const laserIds = [349395,157937,18070,686525,985549];
  const field = (root,id) => root.querySelector(`[id^="tcustomizer-field-${id}-"]`);
  const checked = node => Array.from(node?.querySelectorAll('input[type="checkbox"]:checked,input[type="radio"]:checked') || []);
  const allowed = () => { try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; } };
  let loaded = false;
  let privacyLoading = false;
  let scheduled = false;
  let pendingCart = null;
  const testMode = new URLSearchParams(location.search).get('pc_measurement_test') === '1';
  const consent = () => {
    const api = window.Shopify?.customerPrivacy;
    const marketing = api?.marketingAllowed?.() === true;
    return {analytics_storage:allowed()?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing && api?.saleOfDataAllowed?.() === true?'granted':'denied'};
  };
  const command = function() { window.dataLayer.push(arguments); };
  const sync = () => {
    if (!loaded && !allowed()) return;
    window.dataLayer = window.dataLayer || [];
    command('consent',loaded?'update':'default',consent());
    if (loaded) return;
    loaded = true;
    window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-W9P29G6M';
    document.head.appendChild(script);
  };
  const method = root => {
    const foil = checked(field(root,674810)).length > 0;
    const laser = laserIds.some(id => checked(field(root,id)).length > 0);
    return foil && laser?'foil_laser':foil?'foil':laser?'laser':'none';
  };
  const emit = (root,event,step='',option='',choice='',action='') => {
    if (!allowed() || !states.has(root)) return false;
    const form = root.closest('form');
    const variant = form?.querySelector('[name="id"]')?.value || '';
    const product = (root.closest('[id^="tcustomizer-form-"]')?.getAttribute('id') || '').match(/^tcustomizer-form-(\d+)$/)?.[1] || '';
    const data = {event,pc_product_id:product,pc_variant_id:/^\d+$/.test(variant)?variant:'',pc_personalization_method:method(root),pc_tracking_version:testMode?'2-test':'2',pc_step:step,pc_option:option,pc_choice:choice,pc_action:action};
    try { sync(); window.dataLayer.push(data); return true; } catch { return false; }
  };
  const once = (root,event,step='') => {
    const state = states.get(root);
    const key = event+':'+step;
    if (state && !state.sent.has(key) && emit(root,event,step)) state.sent.add(key);
  };
  const optionFor = target => {
    if (target.closest('[name="pc-charms-choice"]')) return 'charms';
    if (target.closest('[name="pc-stitch-enabled"]')) return 'stitching';
    if (target.closest('.pc-thread__grid,#pc-horse-thread')) return 'thread';
    if (['flap','left'].includes(target.dataset?.pcRibbon)) return 'ribbon_'+target.dataset.pcRibbon;
    const id = target.closest('.tcustomizer-field')?.id?.match(/^tcustomizer-field-(\d+)-/)?.[1];
    if (fields[id]) return fields[id];
    if (target.closest('.tcustomizer-field--FileUpload')) return 'artwork';
    if (target.closest('.tcustomizer-field--Text')) return 'laser_text';
    if (target.closest('#pc-classic-stitch')) return 'stitching';
    return '';
  };
  const stepFor = option => /^(foil|laser|artwork)/.test(option)?'personalization':'accessories';
  const safeChoice = (target,option) => {
    if (['eyelets','elastic','foil'].includes(option)) return colors[target.value] || 'other_catalog_option';
    if (option.startsWith('ribbon_')) return ['none','red','blue'].includes(target.dataset?.pattern)?target.dataset.pattern:'other_catalog_option';
    if (option === 'thread') return target.value.match(/^N0[1-9]\b/)?.[0] || 'other_catalog_option';
    if (option === 'charms') return target.value === 'yes'?'yes':'none';
    if (option === 'stitching') return target.value === 'yes'?'yes':'none';
    if (option.startsWith('laser_') && option !== 'laser_text') return 'enabled';
    if (option === 'artwork') return target.files?.length?'provided':'empty';
    return target.value?.trim()?'provided':'empty';
  };
  const interact = event => {
    if (!event.isTrusted || !allowed()) return;
    const target = event.target;
    const root = target.closest?.('.pc-configurator');
    if (!root || !states.has(root) || !target.matches('input,textarea,select')) return;
    const option = optionFor(target);
    if (!option) return;
    const step = stepFor(option);
    once(root,'pc_config_view');
    once(root,'pc_config_start');
    once(root,'pc_config_step',step);
    if (event.type !== 'change') return;
    const choice = safeChoice(target,option);
    const action = target.matches('[type="checkbox"],[type="radio"]')?(target.checked?'select':'remove'):'complete';
    const state = states.get(root);
    const signature = choice+':'+action;
    const key = target.matches('[type="checkbox"]')?option+':'+choice:option;
    if (state.choices.get(key) === signature) return;
    if (emit(root,'pc_config_choice',step,option,choice,action)) state.choices.set(key,signature);
  };
  const snapshot = root => {
    const result = [];
    [220579,667408,674810,...laserIds].forEach(id => {
      const node = field(root,id);
      if (!node) return;
      const option = fields[id];
      const values = checked(node).map(input => safeChoice(input,option));
      (values.length?values:['none']).forEach(value => result.push([option,value]));
    });
    ['pc-charms-choice','pc-stitch-enabled'].forEach((name,index) => {
      const input = root.querySelector(`[name="${name}"]:checked`);
      if (input) result.push([index?'stitching':'charms',safeChoice(input,index?'stitching':'charms')]);
    });
    if (root.querySelector('[name="pc-stitch-enabled"]:checked')?.value === 'yes' || root.querySelector('#pc-horse-thread')) {
      const input = root.querySelector('.pc-thread__grid input:checked');
      if (input) result.push(['thread',safeChoice(input,'thread')]);
    }
    root.querySelectorAll('[data-pc-ribbon]:checked').forEach(input => { const option=optionFor(input); if (option) result.push([option,safeChoice(input,option)]); });
    return result;
  };
  const errors = root => {
    const found = new Set();
    root.querySelectorAll('.pc-field-error,[aria-invalid="true"]').forEach(el => {
      const option = optionFor(el);
      if (option) found.add(option);
    });
    found.forEach(option => emit(root,'pc_config_error',stepFor(option),option,'validation','blocked'));
    return found.size;
  };
  const attempt = event => {
    if (!event.isTrusted || !allowed()) return;
    const form = event.type === 'submit'?event.target:event.target.closest?.('#tcustomizer-add,button[name="add"]')?.closest('form');
    const root = form?.querySelector('.pc-configurator');
    const state = states.get(root);
    if (!state || Date.now()-state.lastAttempt < 1200) return;
    state.lastAttempt = Date.now();
    once(root,'pc_config_start');
    emit(root,'pc_config_submit','cart');
    pendingCart = {root,at:Date.now(),choices:snapshot(root)};
    setTimeout(() => { if (errors(root)) pendingCart = null; },0);
  };
  const observer = typeof IntersectionObserver === 'function'?new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const info = targets.get(entry.target);
      if (!info) return;
      info.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
      if (info.visible) {
        once(info.root,'pc_config_view');
        once(info.root,info.step === 'review'?'pc_config_review':'pc_config_step',info.step);
      }
    });
  },{threshold:[0,0.25]}):null;
  const discover = () => {
    scheduled = false;
    roots.forEach(root => { if (!root.isConnected) roots.delete(root); });
    document.querySelectorAll('.pc-configurator').forEach(root => {
      if (!states.has(root)) { states.set(root,{sent:new Set(),choices:new Map(),lastAttempt:0}); roots.add(root); }
      const review = root.closest('form')?.querySelector('#pc-config-total h3');
      [[root.querySelector('#pc-step_included') || root.querySelector('.tcustomizer__heading'),'accessories'],[root.querySelector('#pc-step_personal'),'personalization'],[review,'review']].forEach(([el,step]) => {
        if (!el || watched.has(el)) return;
        watched.add(el); targets.set(el,{root,step,visible:false}); observer?.observe(el);
      });
    });
    if (!window.Shopify?.customerPrivacy && !privacyLoading && window.Shopify?.loadFeatures) {
      privacyLoading = true;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],() => { privacyLoading=false; refreshConsent(); });
    }
  };
  const refreshConsent = () => {
    if (loaded) sync();
    if (!allowed()) { pendingCart=null; return; }
    roots.forEach(root => {
      const nodes = [root.querySelector('#pc-step_included') || root.querySelector('.tcustomizer__heading'),root.querySelector('#pc-step_personal'),root.closest('form')?.querySelector('#pc-config-total h3')];
      nodes.forEach(el => { const info=el && targets.get(el); if (info?.visible) { once(root,'pc_config_view'); once(root,info.step==='review'?'pc_config_review':'pc_config_step',info.step); } });
    });
  };
  const baseFetch = window.fetch;
  window.fetch = function(resource,init) {
    const result = baseFetch.apply(this,arguments);
    if (!init?.byTcustomizer || !/\/cart\/add\.js(?:[?#]|$)/.test(String(resource)) || !pendingCart || Date.now()-pendingCart.at > 30000) return result;
    const pending = pendingCart;
    pendingCart = null;
    result.then(response => {
      if (!allowed()) return;
      if (response.ok) {
        emit(pending.root,'pc_config_cart','cart','','','success');
        pending.choices.forEach(([option,value]) => emit(pending.root,'pc_config_selection','cart',option,value,'in_cart'));
      } else emit(pending.root,'pc_config_error','cart','cart','server','failed');
    },() => { emit(pending.root,'pc_config_error','cart','cart','network','failed'); }).catch(() => {});
    return result;
  };
  document.addEventListener('change',interact);
  document.addEventListener('input',interact);
  window.addEventListener('click',attempt,true);
  window.addEventListener('submit',attempt,true);
  document.addEventListener('invalid',event => {
    const root=event.target.closest?.('.pc-configurator');
    const option=optionFor(event.target);
    if (root && option) emit(root,'pc_config_error',stepFor(option),option,'required','blocked');
  },true);
  document.addEventListener('visitorConsentCollected',refreshConsent);
  const main=document.querySelector('main');
  if (main) new MutationObserver(() => { if (!scheduled) { scheduled=true; requestAnimationFrame(discover); } }).observe(main,{childList:true,subtree:true});
  discover();
})();
